module.exports = __webpack_public_path__ + "static/media/spinner_black.20bc2181.svg";